import { useEffect } from "react";
import { useLanguage } from "@/lib/LanguageContext";

/**
 * Dynamically updates <html lang>, <title>, and meta description
 * whenever the user switches between Indonesian and English.
 */
const SeoManager = () => {
  const { lang } = useLanguage();

  useEffect(() => {
    const isId = lang === "id";
    document.documentElement.lang = lang;

    document.title = isId
      ? "RS Bhayangkara Tarakan | Rumah Sakit Terpercaya di Kalimantan Utara"
      : "RS Bhayangkara Tarakan | Trusted Hospital in North Kalimantan";

    const desc = isId
      ? "RS Bhayangkara Tarakan - Rumah sakit resmi Polda Kalimantan Utara. IGD 24 Jam, poliklinik spesialis, dokter bersertifikat & fasilitas modern. Buat janji temu via WhatsApp."
      : "RS Bhayangkara Tarakan - Official hospital of North Kalimantan Police. 24 Hour ER, specialist clinics, board-certified doctors & modern facilities. Book via WhatsApp.";

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[property="og:locale"]', "content", isId ? "id_ID" : "en_US");
  }, [lang]);

  return null;
};

export default SeoManager;
